import React, { useState, useEffect } from 'react';
import { 
    Box, Paper, Typography, List, ListItem, 
    ListItemText, ListItemIcon, Chip, CircularProgress 
} from '@mui/material';
import { History, Edit, Person, Visibility, Delete, Add } from '@mui/icons-material';
import api from '../../../api/axios';
import { parseUtc } from '../../../utils/time';


const ActionIcon = ({ action }) => {
    if (action.includes('CREATE')) return <Add color="success" />;
    if (action.includes('UPDATE')) return <Edit color="primary" />;
    if (action.includes('DELETE')) return <Delete color="error" />;
    if (action.includes('VIEW')) return <Visibility color="action" />;
    return <History color="action" />;
};

const JobAuditLog = ({ jobId }) => {
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadLogs();
    }, [jobId]);

    const loadLogs = async () => {
        try {
            // Filter by entity_type='job' and entity_id=jobId
            const res = await api.get(`/admin/audit-logs`, {
                params: {
                    entity_type: 'job',
                    entity_id: jobId
                }
            });
            setLogs(res.data);
        } catch (err) {
            console.error(err);
        }
        setLoading(false);
    };

    if (loading) return <CircularProgress />;

    return (
        <Box>
            <Typography variant="h6" gutterBottom sx={{ mb: 3 }}>
                Activity Log
            </Typography>
            
            {logs.length === 0 ? (
                <Paper elevation={0} sx={{ p: 4, textAlign: 'center', border: '1px dashed #E2E8F0', borderRadius: 3 }}>
                    <Typography color="text.secondary">No activity recorded yet</Typography>
                </Paper>
            ) : (
                <Paper elevation={0} sx={{ border: '1px solid #E2E8F0', borderRadius: 3, overflow: 'hidden' }}>
                    <List disablePadding>
                        {logs.map((log, index) => (
                            <React.Fragment key={log.id}>
                                <ListItem sx={{ py: 2 }}>
                                    <ListItemIcon>
                                        <ActionIcon action={log.action} />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary={
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                <Typography variant="subtitle2" fontWeight={600}>
                                                    {log.action.replace(/_/g, ' ')}
                                                </Typography>
                                                <Chip 
                                                    label={parseUtc(log.created_at).toLocaleString()} 
                                                    size="small" 
                                                    variant="outlined" 
                                                    sx={{ height: 20, fontSize: '0.7rem' }} 
                                                />
                                            </Box>
                                        }
                                        secondary={
                                            <Box>
                                                <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                                                    User ID: {log.user_id} • IP: {log.ip_address || 'Unknown'}
                                                </Typography>
                                                {log.details && (
                                                    <Typography 
                                                        variant="caption" 
                                                        display="block" 
                                                        sx={{ 
                                                            mt: 1, 
                                                            fontFamily: 'monospace', 
                                                            bgcolor: '#F8FAFC', 
                                                            p: 1, 
                                                            borderRadius: 1 
                                                        }}
                                                    >
                                                        {log.details}
                                                    </Typography>
                                                )}
                                            </Box>
                                        }
                                    />
                                </ListItem>
                                {index < logs.length - 1 && <Divider component="li" />}
                            </React.Fragment>
                        ))}
                    </List>
                </Paper>
            )}
        </Box>
    );
};

export default JobAuditLog;
